import React, {useEffect, useRef} from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import {fetchProfile, doLogout, reset} from '../login/userSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import styles from '../styles/header/Navbar.module.scss';


const UserTab = () => {

    const dispatch = useDispatch();
    let user = useSelector(state => state.user); 
    const router = useRouter();
    const isMounted = useRef(null);

    useEffect( () => {  
            isMounted.current = true;
            let status = user.status == 'idle'  ? true : false;
            if (status) {
                dispatch(fetchProfile());
            }
            
            return () => {
                isMounted.current = false;
            }
        }, []
    );

    async function handleLogout() {
        try {
            await dispatch(doLogout('logout'));
        } catch(err) {
        }
        dispatch(reset());
        router.push('/');
    }

    const userGreeting = 
        <span className="icon-user">
          
            { user.firstName!= null && user.firstName!=''  ? 
            <>
                <span className={`${styles.userInit} `}>
                {user.firstName[0]}{user.lastName[0]}
                </span> Contul meu
            </>
            : 'Hello!'}
        </span>  
    ;

    const goToAccount = () => {router.push('/');}
    const accountOpt =     
        <DropdownButton 
            title={userGreeting} 
            drop="down" 
            variant="link" 
            menuAlign="right"
            className={`order-1 order-lg-3 d-none d-md-block green ${styles.dropButton}`}
        >
            <Dropdown.Item as="button" onClick={goToAccount} >Contul meu</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="button" onClick={handleLogout}>
                <FontAwesomeIcon icon={faPowerOff} className="me-1" height="16" width="16" />
                Logout
            </Dropdown.Item>
        </DropdownButton>;

    const loginOptLabel = 
        <>
            <FontAwesomeIcon icon={faUser} className="me-0 me-lg-1" height="16" width="16" /> 
            <span className="d-none d-lg-inline-block">  
                Contul meu
            </span>
        </>
        ;

    const loginOpt =     
        <DropdownButton title={loginOptLabel} drop="down" variant="link" 
            menuAlign="right"
            className={`order-1 order-lg-3 green d-none d-md-block ${styles.dropButton}`}
        >
            <Dropdown.Item as="button" onClick={goToAccount} className="bg-green">Login</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="button" onClick={handleLogout}>Cont nou</Dropdown.Item>
        </DropdownButton>;


    return (
        user.isLoggedIn ? accountOpt : loginOpt
    );
}

export default UserTab;